/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfirmDataApiRoaming } from '../../models/confirm-data-api-roaming';
import { RoamingDataApiRoaming } from '../../models/roaming-data-api-roaming';

export interface ApiRoamingFinregClientAppPhonePost$Params {

/**
 * Request language.
 */
  lang?: string;
  
    /**
     * Registration confirmation data
     */
    body?: ConfirmDataApiRoaming
}

export function apiRoamingFinregClientAppPhonePost(http: HttpClient, rootUrl: string, params?: ApiRoamingFinregClientAppPhonePost$Params, context?: HttpContext): Observable<StrictHttpResponse<RoamingDataApiRoaming>> {
  const rb = new RequestBuilder(rootUrl, apiRoamingFinregClientAppPhonePost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoamingDataApiRoaming>;
    })
  );
}

apiRoamingFinregClientAppPhonePost.PATH = '/api/Roaming/finregClientAppPhone';
